<div *ngIf="user$ | async as user; else elseForm;">
  <div class="step-title">Verification link sent!</div>

  <div class="mb-5">
    A verification email has been sent to
    <strong>{{ user.email }}</strong>.<br><br>
    Click on the link in the email to verify.<br><br>
    Once you have verified your email address, please click “I have verified my email” button below to continue.
  </div>
  <div class="row justify-content-end mb-5">
    <div class="mr-4 d-flex align-items-center red-text" *ngIf="notVerifiedError">Email Not Verified Yet</div>
    <button class="action-button btn btn--paybee btn--purple" (click)="onUpdateUser()"> I have verified my email </button>
  </div>
  <div class="divider mb-3"></div>
  <div class="mb-2" style="font-size:12px;">Didn’t receive the email?</div>
  <div class="link cursor-pointer mb-2" (click)="onResend()">Resend verification email</div>
  <div class="link cursor-pointer mb-2" (click)="onChangeEmail()">Change email address</div>
</div>

<ng-template #elseForm>
  <div class="step-title">Sign Up</div>
  <div class="step-description">
    <div class="text"> Already have an account? </div>
    <span (click)="onLogin()" class="help">Login</span>
  </div>

  <div class="mb-3" [formGroup]="form">
    <div class="row field-container">
      <div class="col-12">
        <mdb-form-control class="form-fill" >
          <app-mdbp-input mdbInput formControlName="organization"  label='Organization Name'></app-mdbp-input>
          <span class="form-fill-error"  *ngIf="form.controls.organization.hasError('required') && form.controls.organization.touched ">Please provide Organization Name</span>
      </mdb-form-control>
      </div>
    </div>

    <div class="row field-container">
      <div class="col-12">
        <mdb-form-control class="form-fill" >
          <app-mdbp-input mdbInput formControlName="email" type="email"  autocomplete="email" label='Email'></app-mdbp-input>
          <span class="form-fill-error" *ngIf="form.controls.email.touched">{{getUserErrorMessage()}}</span>
      </mdb-form-control>
      </div>
    </div>

    <div class="row field-container">
      <div class="col-12">
        <mdb-form-control class="form-fill" >
          <app-mdbp-input mdbInput formControlName="password" type="password"   label='Password'></app-mdbp-input>
          <span class="form-fill-error" *ngIf="form.controls.password.touched">{{getPasswordErrorMessage()}}</span>
      </mdb-form-control>
      </div>
    </div>

    <div class="row field-container">
      <div class="col-12">
        <mdb-form-control class="form-fill" >
          <app-mdbp-input mdbInput formControlName="repeatPassword" type="password"   label='Repeat password'></app-mdbp-input>
          <span class="form-fill-error"  *ngIf="form.controls.repeatPassword.invalid && form.controls.repeatPassword.touched">Password does not match</span>
      </mdb-form-control>
      </div>
    </div>

    <div class="row field-container justify-content-start align-items-center">
      <div class="col-12 terms-container mb-4">
        <div class="form-checkbox terms">
          <input
            mdbCheckbox
            class="form-check-input form-checkbox-input term"
            type="checkbox"
            value=""
            id="terms"
            formControlName="terms" 
          />
          <label class="form-check-label form-checkbox-label terms" for="terms">
            Check if you agree with the 
          </label>
        </div>
        <a target="_blank" href='https://paybee.io/tos.html' class="license"> Paybee Terms of Service.</a>
      </div>
      <div class="mat-form-field-description mb-3 pr-5">
        <span class='form-fill-error' *ngIf="form.controls.terms.touched && form.controls.terms.invalid">{{ getTermsErrorMessage() }}</span>
      </div>
    </div>

    <div class="row justify-content-end">
      <div class="d-flex col-12 col-md-6 justify-content-end">
        <button class="action-button btn btn--paybee btn--purple" (click)="onNext()"> Create Account </button>
      </div>
    </div>
  </div>
</ng-template>
